import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

import { GUEST_ROOM_CHAT } from '@/shared/utils/constants'

import { setCallSessionPropsResolver } from './lazy-route-props'

export const callGuestSessionBeforeEnter = async (
  to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  const [{ useWebRTC }, { callSessionPropsFn }] = await Promise.all([
    import('@/entities/webrtc'),
    import('./callSessionPropsFn'),
  ])
  setCallSessionPropsResolver(callSessionPropsFn)

  const { sessionId } = to.params
  const { getRTCSessionFacadeById } = useWebRTC()

  if (sessionId && typeof sessionId === 'string' && getRTCSessionFacadeById(sessionId)) {
    if (!to.meta) {
      to.meta = {}
    }
    to.meta.callSessionProps = callSessionPropsFn(to)
    next()
  } else {
    next({ name: GUEST_ROOM_CHAT })
  }
}
